import cookie from 'js-cookie';

const Logout = () => {
}

export default Logout;
